import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "core/typography/Typography";

const SavedEvaluationPage = ({titleId, messageId}) => {
  const intl = useIntl();
  const message = _.chain(
    intl.formatMessage({
      id: messageId,
      defaultMessage: "Evaluation saved",
    })
  )
    .split("\n")
    .map((part, index) => <div key={index}>{part}</div>)
    .value();

  return (
    <>
      <Typography
        className="title-2 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
          id={titleId}
            defaultMessage="Evaluation already registered"
          />
        }
      />
      <div className="separator-title" />

      <div className="justify-content-space-between ">
        <div className="info-text" style={{ maxWidth: "60%" }}>
          {message}
        </div>
        <div style={{ maxWidth: "50%" }}>
          <img src={"/static/img/dav_logo.png"} alt="davidson-logo" />
        </div>
      </div>
    </>
  );
};

export default SavedEvaluationPage;
